<template>
  <div
    ref="videoContainer"
    class="dui-video"
  >
    <div
      :id="`youtube-video-${ _uid }`"
      class="youtube-video"
    />
  </div>
</template>

<script>
import youTubeApi from '@dui/helpers/youtube-api';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    vm: {
      videoId: null,
      videoPlayer: null,
    },
  }),
  watch: {
    url: function() {
      this.setupVideoFromUrl();
    },
  },
  mounted() {
    this.setupVideoFromUrl();
  },
  methods: {
    removeExistingVideo() {
      if (!this.vm.videoId) {
        return;
      }

      this.$el.querySelector(`#youtube-video-${ this._uid }`).remove();
      const newVideo = document.createElement('div');
      newVideo.classList.add('youtube-video');
      newVideo.id = `youtube-video-${ this._uid }`;
      this.$refs.videoContainer.appendChild(newVideo);
      this.$set(this.vm, 'videoId', null);
      this.$set(this.vm, 'videoPlayer', null);
    },

    setupYoutubeVideo() {
      const videoPlayer = new window.YT.Player(
        `youtube-video-${ this._uid }`,
        {
          height: '100%',
          width: '100%',
          videoId: this.vm.videoId,
          playerVars: {
            controls: 1,
            modestbranding: 1,
            rel: 0, // disabled related videos
            start: 0,
          },
          // origin: "https://reedsy.com"
        },
      );

      this.$set(this.vm, 'videoPlayer', videoPlayer);
    },

    setupVideoFromUrl() {
      this.removeExistingVideo();
      const videoId = youTubeApi.getVideoIdFromUrl(this.url);
      if (!videoId) {
        this.$emit('invalid-video');
        return;
      }

      this.$set(this.vm, 'videoId', videoId);
      this.$emit('valid-video');
      youTubeApi.init(this.setupYoutubeVideo);
    },
  },
};
</script>
